import { useEffect, lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/optina/Navbar";
import Footer from "@/components/optina/Footer";
import QualificationPopup from "@/components/optina/QualificationPopup";
import QuotePopup from "@/components/optina/QuotePopup";
import { QuoteProvider } from "@/components/optina/QuoteContext";
import Home from "@/pages/Home";
import ScrollToTop from "@/components/optina/ScrollToTop";

// Code splitting : pages non-Home chargées à la demande → réduit le JS initial
const Assurance = lazy(() => import("@/pages/Assurance"));
const AssuranceEmprunteur = lazy(() => import("@/pages/AssuranceEmprunteur"));
const AssuranceProfessionnelle = lazy(() => import("@/pages/AssuranceProfessionnelle"));
const AssuranceProfessionnelleSecteur = lazy(() => import("@/pages/AssuranceProfessionnelleSecteur"));
const MultirisqueDecennale = lazy(() => import("@/pages/MultirisqueDecennale"));
const MetierPage = lazy(() => import("@/pages/MetierPage"));
const ProduitPage = lazy(() => import("@/pages/ProduitPage"));
const Energie = lazy(() => import("@/pages/Energie"));
const BlogIndex = lazy(() => import("@/pages/BlogIndex"));
const BlogArticle = lazy(() => import("@/pages/BlogArticle"));
const FaqPage = lazy(() => import("@/pages/FaqPage"));
const EpargnePatrimoine = lazy(() => import("@/pages/EpargnePatrimoine"));
const MentionsLegales = lazy(() => import("@/pages/MentionsLegales"));
const PolitiqueConfidentialite = lazy(() => import("@/pages/PolitiqueConfidentialite"));
const RendezVous = lazy(() => import("@/pages/RendezVous"));
const AdminLeads = lazy(() => import("@/pages/AdminLeads"));

function App() {
  useEffect(() => {
    document.title = "OPTINA — Je compare. Vous économisez.";
  }, []);

  return (
    <div className="App bg-brand-sand text-brand-ink min-h-screen">
      <BrowserRouter>
        <QuoteProvider>
          <ScrollToTop />
          <Navbar />
          <Suspense fallback={<div className="min-h-screen bg-brand-sand" />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/assurance" element={<Assurance />} />
              <Route path="/assurance/emprunteur" element={<AssuranceEmprunteur />} />
              <Route path="/assurance/professionnelle" element={<AssuranceProfessionnelle />} />
              <Route path="/assurance/professionnelle/multirisque-decennale" element={<MultirisqueDecennale />} />
              <Route path="/metier/:slug" element={<MetierPage />} />
              <Route path="/produit/:slug" element={<ProduitPage />} />
              <Route path="/assurance/professionnelle/:secteur" element={<AssuranceProfessionnelleSecteur />} />
              <Route path="/energie" element={<Energie />} />
              <Route path="/epargne-patrimoine" element={<EpargnePatrimoine />} />
              <Route path="/blog" element={<BlogIndex />} />
              <Route path="/blog/:slug" element={<BlogArticle />} />
              <Route path="/faq" element={<FaqPage />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
              <Route path="/rendez-vous" element={<RendezVous />} />
              <Route path="/admin/leads" element={<AdminLeads />} />
            </Routes>
          </Suspense>
          <Footer />
          {/* FloatingWhatsApp désactivé : le pop-up WhatsApp n'apparaît
              désormais qu'en fin de tunnel formulaire (cf. QuotePopup). */}
          <QuotePopup />
          <QualificationPopup />
          <Toaster richColors position="top-right" />
        </QuoteProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
